module.exports = __webpack_public_path__ + "img/04.f999c8a4.jpg";